import { map, flatMap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { DataService, ApiService, InspectionPluginService } from '../../shared/services/index';
import { InspectionPlugin, Inspection } from '../../shared/models/index';
import { InspectionInfoFactoryService } from './inspectionInfo-plugin-factory.service';
import { AppLabels } from '../../utils/appLabels.class';

@Injectable()
export class InspectionInfoPluginService extends InspectionPluginService {
  constructor(
    protected apiService: ApiService,
    protected dataService: DataService,
    private inspectionInfoFactory: InspectionInfoFactoryService
  ) {
    super(apiService, dataService, null, inspectionInfoFactory);
  }

  public updateInspectionInfo(inspectionId: string, pluginId: string, data: any): Observable<any> {
    return this.update(inspectionId, pluginId, data).pipe(
      map((res: InspectionPlugin) => {
        this.dataService.updateInspectionDate(inspectionId, res.config);
        return this.dataService.updatePlugin(inspectionId, res);
      })
    );
  }

  public getTypes(inspectionId: string) {
    const inspection: Inspection = this.dataService.getInspection(inspectionId);
    return inspection.applicationType === 0 ? AppLabels.MAINTENANCE_TYPES : AppLabels.OPTIMIZATION_TYPES;
  }

  public getAllTypes() {
    return [...AppLabels.MAINTENANCE_TYPES, ...AppLabels.OPTIMIZATION_TYPES];
  }

  private update(inspectionId: string, pluginId: string, data: any): Observable<any> {
    return this.inspectionInfoFactory.updateInspectionInfo(inspectionId, pluginId, data).pipe(
      flatMap((plugin) => {
        if (this.isInspectionInOffline(inspectionId)) {
          return of(plugin);
        }
        return this.apiService.post(plugin.postServerUrl, plugin.config);
      })
    );
  }
}
